module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-zip-fill-65e66d0e.svg";